module.exports = __webpack_public_path__ + "static/media/girl_page02.38eafd79.png";